import { RootState } from 'store';
import { useSelector } from 'react-redux';
import {
  isAutorizedUser as checkIsAutorizedUser,
  isUnautorizedUser as checkIsUnautorizedUser,
  isUnknownUser as checkIsUnknownUser,
} from 'common/utils/userTypes';

import { STATE } from '../types';

export const useUserType = () => {
  const userType = useSelector(
    (rootState: RootState) => rootState[STATE].userType,
  );
  return userType;
};

// @see also
// 1. useUserTypes src/common/hooks/useUserTypes.ts
// 2. useIsAutorizedUser src/store/features/auth/selectors/userType.ts - THIS
// 3. isAutorizedUser src/common/utils/userTypes.ts
//
export const useIsAutorizedUser = () => {
  const userType = useUserType();
  return checkIsAutorizedUser(userType);
};

export const useIsUnauthorizedUser = () => {
  const userType = useUserType();
  return checkIsUnautorizedUser(userType);
};

export const useIsUnknownUser = () => {
  const userType = useUserType();
  return checkIsUnknownUser(userType);
};
